import * as yup from "yup";

declare module "yup" {
    export interface StringSchema {
        /**
        * Check for name validity.
        *       
        * @param {Boolean} [required=false] Is name required.
        * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
        */
        emailList(
            required: boolean,
            errorMessage?: string
        ): StringSchema;
    }
}
const YUP_NAME_METHOD = "emailList";
const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
yup.addMethod(yup.string, YUP_NAME_METHOD, function yupEmailList(
    required: boolean,
    errorMessage: ""
) {
    const errMsg =
        typeof errorMessage === "string" && errorMessage
            ? errorMessage
            : "Email list is not valid.";

    return this.test(YUP_NAME_METHOD, errMsg, (value: string) => {
        if (!value) return !required;

        // Split the string by commas
        const emails = value.split(",").map((email) => email.trim());

        // Validate each email using the regex
        return emails.every((email) => emailRegex.test(email));
    });
});
